module.exports = __webpack_public_path__ + "static/audit.926617ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/audit.png
// module id = 786
// module chunks = 12729642909824